import instance from '../../Api';

export const getOrdersHistory = async (config) => {
  const api = await instance();
  let data = await api
    .post('/monitor/orders-history', config)
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};
